import * as React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import withStyles from '@material-ui/core/styles/withStyles'
import RadioGroup from '@material-ui/core/RadioGroup'
import Rating from '@material-ui/lab/Rating'
import { Form, Field } from '@oakwood/formit'
import { useGlobal } from 'api'
import FormitButton from 'containers/FormitButton'
import FormControlLabel from 'components/FormControlLabel'
import Link from 'components/Link'
import Radio from 'components/Radio'
import TextField from 'components/TextField'
import Typography from 'components/Typography'

export const styles = (theme) => ({
  root: {
    ...theme.mixins.verticalRhythm(2),
    padding: 'var(--coa-section-spacing) var(--coa-container-spacing)',
  },
  fieldGroup: theme.mixins.verticalRhythm(1),
})

const ReviewsForm = React.forwardRef(function ReviewsForm(props, ref) {
  const { classes, className, ...other } = props

  const { settings } = useGlobal()

  return (
    <Form className={clsx(classes.root, className)} ref={ref} {...other}>
      <Typography align="center" component="p" variant="h5" paragraph>
        Write a review
      </Typography>

      <Field
        component={TextField}
        name="name"
        label="Your name"
        variant="filled"
        fullWidth
        required
        autoFocus
      />

      <Field
        component={TextField}
        name="email"
        type="email"
        label="Your email"
        variant="filled"
        fullWidth
        required
      />

      <div className={classes.fieldGroup}>
        <Typography>Your rating</Typography>

        <Field name="rating">
          {({ field }) => (
            <Rating
              {...field}
              onChange={(event, newValue) => {
                field.onChange({ target: { name: field.name, value: newValue } })
              }}
            />
          )}
        </Field>
      </div>

      <Field
        component={TextField}
        name="title"
        label="Review title"
        variant="filled"
        fullWidth
        required
        autoFocus
      />

      <Field
        component={TextField}
        name="message"
        label="Your review"
        variant="filled"
        fullWidth
        required
        multiline
        rows={5}
      />

      <div className={classes.fieldGroup}>
        <Typography>Would you recommend this product?</Typography>

        <Field component={RadioGroup} name="wouldRecommend">
          <FormControlLabel control={<Radio />} label="Yes" value="1" />

          <FormControlLabel control={<Radio />} label="No" value="0" />
        </Field>
      </div>

      <Typography component="p" variant="caption">
        By continuing you agree to our{' '}
        <Link href={settings.termsPageUrl} target="_blank" underline="always" variant="inherit">
          Terms and Conditions
        </Link>
      </Typography>

      <FormitButton variant="contained" type="submit" fullWidth>
        Submit
      </FormitButton>
    </Form>
  )
})

ReviewsForm.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
}

export default withStyles(styles)(ReviewsForm)
